import {GeneConverter} from "../../services/GeneConverter";

export function PlasmidViewerConverter() {
    return (<section>
        <GeneConverter/>
    </section>)
}